import * as React from 'react';
import { Grid, SemanticWIDTHS, Table } from 'semantic-ui-react';
import { UpdateDataFileContainer } from '../../data-upload/update-data-file';
import { IndicatorConfigOptions } from '../indicator-config-options';
import { IndicatorConfigActionsContainer } from '../indicator-config-actions';
import { IndicatorMappingOptions } from '../../../components';
import { IAppIndicatorConfig, IColumns } from '../../../interfaces';
import { CONFIG_VIEW_TEXT, INDICATOR_KEY } from '../../../constants';
import './indicator-config-view.less';

/**
 * View for "Indicators Config" component
 */
export class IndicatorConfigView extends React.Component<IIndicatorConfigViewProps> {
  public readonly MAX_COLUMNS: SemanticWIDTHS = 5;
  public readonly CONTENT_WIDTH: SemanticWIDTHS = 12;

  constructor(props: IIndicatorConfigViewProps) {
    super(props);
  }

  public getConfigRows(): JSX.Element[] {
    const rows: JSX.Element[] = [];
    const colIndexes: string[] = Object.keys(this.props.columns);

    for (let i: number = 0; i < colIndexes.length; i++) {
      const colIndex: string = colIndexes[i];

      const row: JSX.Element = (
        <IndicatorMappingOptions
          key={i}
          colIndex={colIndex}
          name={this.props.columns[colIndex]}
          indicatorConfig={this.props.appIndicatorConfig.indicatorConfig}
          factorConfig={this.props.appIndicatorConfig.factorConfig}
          categoryConfig={this.props.appIndicatorConfig.categoryConfig}

          onWarningChange={this.props.onWarningChange}
          onMappingReset={this.props.onMappingReset}
          onIndicatorColMappingChange={this.props.onIndicatorColMappingChange}
          onFactorColMappingChange={this.props.onFactorColMappingChange}
          onCategoryColMappingChange={this.props.onCategoryColMappingChange}
        />
      );
      rows.push(row);
    }
    return rows;
  }

  /** Get header with data load type and column captions */
  public getTableHeader(): JSX.Element {
    const caption: string = CONFIG_VIEW_TEXT.INDICATOR_FIELDS_CONFIG;

    return (
      <Table.Header fullWidth>
        <Table.Row>
          <Table.HeaderCell content={caption} colSpan={this.MAX_COLUMNS} />
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell content={CONFIG_VIEW_TEXT.STATUS_COLUMN_HEADER} />
          <Table.HeaderCell content={CONFIG_VIEW_TEXT.COLUMN_NAME_HEADER} />
          <Table.HeaderCell content={CONFIG_VIEW_TEXT.MAPPING_TYPE_HEADER} />
          <Table.HeaderCell content={CONFIG_VIEW_TEXT.FIELD_NAME_HEADER} />
        </Table.Row>
      </Table.Header>
    );
  }

  /** Table for mapping columns into indicator keys */
  public getConfigTable(): JSX.Element {
    return (
      <Grid.Row columns="equal" centered>
        <Grid.Column width={this.CONTENT_WIDTH}>
          <Table celled compact columns={this.MAX_COLUMNS}>
            {this.getTableHeader()}

            <Table.Body>
              {this.getConfigRows()}
            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid.Row>
    );
  }

  public getConfigActions(): JSX.Element {
    return (
      <Grid.Row columns="equal" centered>
        <Grid.Column width={this.CONTENT_WIDTH}>
          <IndicatorConfigActionsContainer warning={this.props.warning} />
        </Grid.Column>
      </Grid.Row>
    );
  }

  public render(): JSX.Element {
    return (
      <Grid data-component="indicator-config-view">
        <Grid.Row columns="equal" centered>
          <Grid.Column width={this.CONTENT_WIDTH}>
            <UpdateDataFileContainer />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row className="no-padding" columns="equal" centered>
          <Grid.Column width={this.CONTENT_WIDTH}>
            <IndicatorConfigOptions />
          </Grid.Column>
        </Grid.Row>

        {this.props.optionsReady ? this.getConfigTable() : null}
        {this.props.optionsReady ? this.getConfigActions() : null}
      </Grid>
    );
  }
}

export interface IIndicatorConfigViewProps {
  readonly columns: IColumns;
  readonly warning: boolean;
  readonly optionsReady: boolean;
  readonly appIndicatorConfig: IAppIndicatorConfig;

  onWarningChange(warning: boolean): void;
  onMappingReset(colIndex: string): void;
  onIndicatorColMappingChange(colIndex: string, key: INDICATOR_KEY): void;
  onFactorColMappingChange(colIndex: string, key: INDICATOR_KEY): void;
  onCategoryColMappingChange(colIndex: string, key: INDICATOR_KEY): void;
}
